export default __webpack_public_path__ + "static/media/announcement_1@2x.1f89dbc5.png";